import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"
//Styles
import "./Global.css"
import "./App.css"
//Gloabal auth via user
import { useAuthContext } from "./Hooks/useAuthContext"
//Components
import TopNav from "./Components/Navigation/TopNav"
import Home from "./Pages/Home/Home.js"
import Branding from "./Pages/Branding"
import LoginForm from "./Components/LoginForm"

import Users from "./Pages/Users/Users.js"
import Customers from "./Pages/Customers/Customers.js"
import Suppliers from "./Pages/Suppliers/Suppliers.js"
import Products from "./Pages/Products/Products.js"
import Orders from "./Pages/Orders/Orders.js"
import Invoices from "./Pages/Invoices/Invoices.js"
import Reports from "./Pages/Reports/Reports.js"
import PricingContracts from "./Pages/PricingContracts/PricingContracts.js"


import RequestResetPassword from "./Pages/RequestResetPassword.js"
import ResetPassword from "./Pages/Users/ResetPassword.js"

// Background Image
import backgroundImage from "./Images/background.jpg"

function App() {

    const { dispatch, user } = useAuthContext()

    const [form, setForm] = useState({
    });

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"))
    if (user) {
      dispatch({ type: "WELCOMEBACK", payload: user })
    }
  }, [dispatch])

  return (
    <BrowserRouter>
      <div className="app"  style={{backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover"}}>
        <div className="container">
            {!user && (
                <Routes>
                    <Route path="/ResetPassword" element={<RequestResetPassword />} />
                    <Route path="/Users/:userId/ResetPassword/:confirmationCode" element={<ResetPassword />} />
                    <Route path="*" element={<LoginForm />} />
                </Routes>
            )}
            {user && (
                <>
                    <TopNav />
                    <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Users/*" element={<Users />} />
                    <Route path="/Customers/*" element={<Customers />} />
                    <Route path="/Suppliers/*" element={<Suppliers />} />
                    <Route path="/Products/*" element={<Products />} />
                    <Route path="/Orders/*" element={<Orders />} />
                    <Route path="/Invoices/*" element={<Invoices />} />
                    <Route path="/Reports/*" element={<Reports />} />
                    <Route path="/PricingContracts/*" element={<PricingContracts />} />
                


                    {/* Dont forget to remove this!! */}
                    <Route path="/Branding" element={<Branding />} />

           
                    </Routes>
                </>
            )}
        </div>
      </div>
    </BrowserRouter>
  )
}

export default App
